import { z } from 'zod';
import { cursorQuerySchema, paginated, uuidSchema } from './common.js';
export const notificationTypeSchema = z.enum([
    'deposit_paid', 'quote_viewed', 'job_assigned', 'invite_accepted', 'credits_low', 'plan_changed', 'inventory_low', 'trial_expiring', 'message_received', 'stripe_action_required', 'lead_created',
]);
export const notificationSchema = z.object({
    id: uuidSchema,
    workspaceId: uuidSchema,
    type: notificationTypeSchema,
    title: z.string(),
    body: z.string(),
    entity: z.record(z.string(), z.unknown()),
    readAt: z.string().nullable(),
    createdAt: z.string(),
});
export const notificationListResponseSchema = paginated(notificationSchema);
export const notificationsQuerySchema = cursorQuerySchema;
export const markNotificationsReadSchema = z.union([
    z.object({ ids: z.array(uuidSchema).min(1) }),
    z.object({ all: z.literal(true) }),
]);
//# sourceMappingURL=notifications.js.map